var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bean-source-page',{ref:"sourcePage",attrs:{"type":_vm.type,"columns":_vm.columns,"form-columns":_vm.formColumns,"filter-columns":_vm.filterColumns,"actions":_vm.actions,"form":_vm.form,"tabs":_vm.tabs,"title":_vm.$t('model.productDesign'),"batch-actions":_vm.batchActions,"onFetchData":_vm.onFetchData,"resource":"product_designs"}})
}
var staticRenderFns = []

export { render, staticRenderFns }